import { i18n } from '@/plugins/i18n'
import accountStatement from '../components/account-description.vue';
import Vue from 'vue';

const descriptionTemplate = (row, index, datatable) => {
    const Component = Vue.extend(accountStatement);
    const instance = new Component({
        propsData: {
            row,
            index,
            datatable
        },
        i18n
    });

    instance.$mount();
    return instance.$el;
};

export default [
    {
        field: 'id',
        width: 50,
        title: i18n.t('label.identifier'),
        sortable: false,
        textAlign: 'center',
    },
    {
        field: 'wallet_bank_account_id',
        width: 90,
        title: i18n.t('label.accounting_account_id'),
        sortable: false,
        textAlign: 'center',
    },
    // sheba number
    // {
    //     field: 'account_number',
    //     width: 90,
    //     title: i18n.t('label.accounting_account_number'),
    //     sortable: false,
    //     textAlign: 'center',
    // },
    {
        field: 'amount',
        width: 90,
        title: i18n.t('label.amount'),
        sortable: false,
        textAlign: 'center',
    },
    {
        field: 'bank_name',
        width: 90,
        title: i18n.t('label.accounting_bank_name'),
        sortable: false,
        textAlign: 'center',
    },
    {
        field: 'bank_ref_code',
        width: 90,
        title: i18n.t('label.bank_ref_code'),
        sortable: false,
        textAlign: 'center'
    },
    {
        field: 'recorded_at',
        width: 90,
        title: i18n.t('accounting.deposit_date'),
        sortable: false,
        textAlign: 'center',
    },
    {
        field: 'created_at',
        title: i18n.t('label.date'),
        sortable: true,
        textAlign: 'center',
    },
    {
        field: 'description',
        width: 50,
        title: i18n.t('label.description'),
        template: (row, index, datatable) => {
            return descriptionTemplate(row, index, datatable)
        },
        textAlign: 'center'
    }
]